module.exports = __webpack_public_path__ + "static/img/female-bg-tr.a31e9ec6.png";